import { service } from "../utils/request";

// 公告列表
export function AdList(data) {
  return service({
    url: "merch/agent.Shopnotice/lists",
    method: "post",
    data: data
  });
}

// 删除公告
export function delAdList(data) {
  return service({
    url: "merch/agent.Shopnotice/del",
    method: "post",
    data: data
  });
}

// 添加公告
export function pushAdList(data) {
  return service({
    url: "merch/agent.Shopnotice/add",
    method: "post",
    data: data
  });
}

// 编辑公告
export function EditAdList(data) {
  return service({
    url: "merch/agent.Shopnotice/edit",
    method: "post",
    data: data
  });
}

// 详情公告
export function CommentList(data) {
  return service({
    url: "merch/agent.Shopnotice/detail",
    method: "post",
    data: data
  });
}
